@if(nevvonId){
  <div class="tile">
    <p class="summary-heading">Access Your Training</p>
    <div class="button-container no-padding no-margin">
      <button
        (click)="handleRedirect($event)"
        class="view-welcome-letter btn btn-info"
        aria-label="Access your training"
        target="_blank"
      >
        View
    </button>
    </div>
  </div>
}